// Lazy import breaks circular dep: authUser → axios → (deep chain) → api/index.ts → authUser (TDZ)
let _axios = null;
async function getAxios() {
    if (!_axios) {
        _axios = (await import('../plugins/axios.js')).default;
    }
    return _axios;
}

export default {
    async getProfile(payload = {}) {
        const axios = await getAxios();
        const response = await axios.get('v1/auth-user', {
            params: payload,
        });

        return response.data.data;
    },

    async getFullCrmAccess() {
        const axios = await getAxios();
        const response = await axios.get('v1/auth-user/full-crm-access');

        return response.data.data;
    },

    async getAbilities(payload = {}) {
        const axios = await getAxios();
        const response = await axios.get('v1/auth-user/abilities', {
            params: payload,
        });

        return response.data.data;
    },

    async getFeaturePreviews(payload = {}) {
        const axios = await getAxios();
        const response = await axios.get('v1/auth-user/feature-previews', {
            params: payload,
        });

        return response.data.data;
    },

    async triggerScreenPop() {
        const axios = await getAxios();
        await axios.get('v1/auth-user/screen-pop');
    },

    async getCalendarViews() {
        const axios = await getAxios();
        const response = await axios.get('v1/auth-user/calendar-views');
        if (response === null) {
            return null;
        }

        return response.data;
    },

    async getDashboardViews() {
        const axios = await getAxios();
        const response = await axios.get('v1/auth-user/dashboard-views');

        return response.data.data;
    },
};
